import { ColumnsType, Text } from '@agro-club/agroclub-shared'
import { DASH } from 'modules/constants'
import { User } from 'modules/domain/user/types'
import { WarehouseMovementGrouped } from 'modules/domain/warehouses/types'
import { labelQuantity } from 'modules/utils/numbers/formatQuantity'
import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router'
import { AButton } from 'views/components/Analytics'
import { UserLink } from 'views/components/UserLink/UserLink'
import BidRoutes from 'views/pages/Bid/routes'
import APhone from 'views/ui/Phone/APhone'
import { TableTextLink } from 'views/ui/TableTextLink/TableTextLink'

const UserCompanyInfo: FC<{ owner: User }> = ({ owner }) => {
  return (
    <div>
      <UserLink bodysize="bodyMedium" user={owner} />
      <div>
        <APhone phone={owner.phone} />
      </div>
      <Text typography="bodyMedium" color="secondary">
        {owner.profile?.company?.name || DASH}
      </Text>
    </div>
  )
}

const useColumns = (showBidMoveMovements: (sale_bid_id: number) => void): ColumnsType<WarehouseMovementGrouped> => {
  const { t } = useTranslation(['warehouses', 'common'])

  return useMemo(
    () => [
      {
        title: `${t('common:bid')}/${t('common:crop')}`,
        dataIndex: 'product',
        width: 160,
        render: (_, row) => (
          <div>
            <TableTextLink
              id="title"
              tableItemId={String(row.sale_bid_id)}
              to={generatePath(BidRoutes.Details, { id: row.sale_bid_id })}
            >
              {row.sale_bid_id}
            </TableTextLink>
            <Text typography="bodyMedium" color="secondary">{` ${row.product_title}`}</Text>
          </div>
        ),
      },
      {
        title: `${t('detail.seller')}/${t('detail.company')}`,
        dataIndex: 'seller',
        width: 400,
        render: (_, row) => <UserCompanyInfo owner={row.seller} />,
      },
      {
        title: labelQuantity(t('detail.remaining_quantity')),
        dataIndex: 'remaining_quantity',
        align: 'right',
        width: 140,
      },
      {
        title: t('detail.movements'),
        width: 100,
        dataIndex: 'sale_bid_id',
        render: (sale_bid_id) => (
          <AButton onClick={() => showBidMoveMovements(sale_bid_id)} color="secondary" id="completeTask" size="small">
            {t('detail.showRelatedMovements')}
          </AButton>
        ),
      },
    ],
    [showBidMoveMovements, t],
  )
}

export default useColumns
